import { Badge } from '../ui/badge';

export const ACTION_LABELS = {
  draft_product: 'New product',
  edit_product: 'Product edit',
  draft_purchase_order: 'Purchase order',
  match_invoice: 'Invoice match',
  pos_pending_sale: 'Pending sale',
};

const STATUS_STYLES = {
  pending: 'bg-amber-100 text-amber-900 border-amber-300',
  processing: 'bg-sky-100 text-sky-900 border-sky-300',
  approved: 'bg-emerald-100 text-emerald-900 border-emerald-300',
  rejected: 'bg-rose-100 text-rose-900 border-rose-300',
  expired: 'bg-zinc-100 text-zinc-700 border-zinc-300',
};

export const StatusBadge = ({ status, testId }) => (
  <Badge variant="outline" className={`capitalize ${STATUS_STYLES[status] || ''}`} data-testid={testId}>
    {status}
  </Badge>
);

export const formatWhen = (iso) => (iso ? new Date(iso).toLocaleString() : '');
